export interface LoadingStateProps {
  readonly label?: string;
  readonly testId?: string;
}

export function LoadingState({
  label = 'Yükleniyor…',
  testId,
}: LoadingStateProps): JSX.Element {
  return (
    <div
      className="loading"
      role="status"
      aria-live="polite"
      data-testid={testId}
      style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 10 }}
    >
      <span className="spinner" aria-hidden="true" />
      <span>{label}</span>
    </div>
  );
}
